import * as React from 'react';
import { Separator as SeparatorPrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';
const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>(({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}, ref) => <SeparatorPrimitive.Root className={cn('shrink-0 bg-gray-200 dark:bg-white/10', orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]', className)} decorative={decorative} orientation={orientation} ref={ref} {...props} />);
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };